import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/containers/specifics/settings/Page";

export const PATH = "/settings";

function Home() {
	return (
		<>
			<NskHead title="設定" />
			<Component />
		</>
	);
}

export default Home;
